module.exports = __webpack_public_path__ + "img/svg/transger.7f5cb00135e6be263b799821434a9438.svg";